/* angular:styles/component:css;7c860327013d375b7dcf24a9a3211d64328adfcbb7d265786231e16ef20c511d;/app/src/app/shared/animations/round-drop-down-list-v3.ts */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.search-box-wrapper {
  margin-top: 4px;
  position: absolute;
  width: 100%;
}
.activeSearchBox {
  background-color: #ffffff !important;
  border: 1px solid #dfdfdf !important;
}
.additional-charges-form {
  background-color: #f2f2f2;
  width: 100%;
  border-radius: 12px;
  padding-inline-start: 8px;
  padding-top: 3px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 24px;
  padding-left: 15px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  color: #222222;
  border: 1px solid transparent;
  cursor: pointer;
}
.ag-size-small {
  height: 40px;
}
.ag-size-medium {
  height: 48px;
}
.ag-size-large {
  height: 56px;
  border-radius: 16px !important;
}
.additional-charges-form:hover {
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
}
.additional-charges-clickable {
  cursor: pointer;
}
.additional-charges-disabled {
  opacity: 50%;
}
.additional-charges-div {
  position: relative;
  width: 100%;
}
.additional-charges-img {
  position: absolute;
  left: 52px;
  top: 8px;
}
.code-changeable-img {
  position: absolute;
  right: 8px;
  top: 11px;
}
.spacer {
  padding-bottom: 4px;
}
/*# sourceMappingURL=round-drop-down-list-v3.css.map */
